import {useAudioConfig} from "../../model/AudioConfigContext";
import {Box3, Group, MeshLambertMaterial} from "three";
import {useMemo} from "react";
import useGLTF from "./hooks/useGLTF";
import Speaker from "./Speaker";
import CeilingSpeakerMaterial from "./materials/CeilingSpeakerMaterial";

function centralizeSpeaker(asset)
{
    const model = asset.scene;
    const box = new Box3();
    box.setFromObject(asset.scene);
    model.position.x -= (box.min.x + box.max.x) * .5;
    model.position.z -= (box.min.z + box.max.z) * .5;

    asset.scene = new Group();
    asset.scene.add(model);
}

export default function Speakers() {
    const {
        ceilingPositions,
        frontPositions,
        sidePositions,    // used by 5.1 and 7.1
        rearPositions,    // used by 7.1
        frontSpeakersScore,
        ceilingSpeakersScore,
        sideSpeakersScore,
        rearSpeakersScore,
        rearInCeiling,
        subwooferPositions,
        centerPosition,
        ceiling,
        front,
        surround,
        subwoofer,
        center
    } = useAudioConfig();

    const ceilingModel = useGLTF(ceiling.gltf, CeilingSpeakerMaterial, centralizeSpeaker);
    const frontModel = useGLTF(front.gltf, MeshLambertMaterial, centralizeSpeaker);
    const surroundModel = useGLTF(surround.gltf, MeshLambertMaterial, centralizeSpeaker);
    // use duplicates for rear so they can be coloured individually
    const surroundRearModel = useGLTF(surround.gltf, MeshLambertMaterial, centralizeSpeaker);
    const ceilingRearModel = useGLTF(ceiling.gltf, CeilingSpeakerMaterial, centralizeSpeaker);
    const rearModel = useMemo(() => rearInCeiling ? ceilingRearModel : surroundRearModel, [rearInCeiling, surroundRearModel, ceilingRearModel])
    const subwooferModel = useGLTF(subwoofer.gltf, MeshLambertMaterial, centralizeSpeaker);
    const centerModel = useGLTF(center.gltf, MeshLambertMaterial, centralizeSpeaker);

    return (
        <>
            {
                subwooferPositions.map((elm, i) =>
                    <Speaker model={subwooferModel} position={elm.position}
                             rotation={[0, elm.rotation, 0]}
                             config={subwoofer}
                             key={i}
                    />
                )
            }
            <Speaker model={centerModel} position={centerPosition.position}
                     speakerOffset={center.speakerOffset}
                     config={center}
                     rotation={[0, centerPosition.rotation, 0]}/>
            {
                frontPositions.map((elm, i) =>
                    <Speaker model={frontModel} position={elm.position}
                             rotation={[0, elm.rotation, 0]}
                             score={frontSpeakersScore}
                             config={front}
                             key={i}
                    />
                )
            }
            {
                sidePositions.map((elm, i) =>
                    <Speaker model={surroundModel} position={elm.position} rotation={[0, elm.rotation, 0]}
                             score={sideSpeakersScore}
                             config={surround}
                             key={i}/>
                )
            }
            {
                rearPositions.map((elm, i) =>
                    <Speaker model={rearModel} position={elm.position} rotation={[0, elm.rotation, 0]}
                             score={rearSpeakersScore}
                             config={rearInCeiling ? ceiling : surround}
                             key={i}/>
                )
            }
            {
                ceilingPositions.map((elm, i) =>
                    <Speaker model={ceilingModel} position={elm.position} key={i} score={ceilingSpeakersScore}
                             config={ceiling} />
                )
            }
        </>
    );
}